import React from 'react';
import { useAppChat } from '@/context/AppChatContext';
import MainAppChat from '@/components/chat/MainAppChat';
import { useWebsites } from '@/context/WebsitesContext';

const Chat = () => {
  const chatContext = useAppChat();
  const { currentWebsite } = useWebsites();

  if (!currentWebsite) {
    return (
      <div className="flex items-center justify-center h-full">
        <p className="text-muted-foreground">Please select a website to start chatting.</p>
      </div>
    );
  }

  return (
    <div className="h-full w-full">
      <MainAppChat 
        {...chatContext}
        onSend={() => chatContext.sendMessage(chatContext.input)}
        scrollRef={chatContext.scrollRef}
        currentWebsite={currentWebsite}
        isEditingPost={chatContext.isEditingPost}
        editingPostData={chatContext.editingPostData}
        onContentUpdate={chatContext.updatePostContent}
        onCloseEditChat={chatContext.stopEditingPost}
      />
    </div>
  );
};

export default Chat;
